module.exports = __webpack_public_path__ + "img/joszaki-head-xmas.a8bf270.svg";